export enum StepName {
  commercialisation = 'Commercialisation',
  offresAValider = 'Offres à valider',
  ventesEnCours = 'Ventes en cours',
  vendu = 'Vendu'
}
